import type { FavoriteCollection, PageBookmark, ReaderSettings, SortKey } from '../types/pdf';
import { request } from './pdfService';
import { apiUrl } from './api';

export interface GlobalReaderState {
  favorites: string[];
  favoriteLists?: FavoriteCollection[];
  bookmarks: Record<string, PageBookmark[]>;
  hiddenIds?: string[];
  settings: ReaderSettings;
  activeId: string | null;
  sort: SortKey;
}
export const stateService = {
  get: () => request<{ state: GlobalReaderState | null; updatedAt: string | null }>('/api/state'),
  save: (state: GlobalReaderState) => request<{ updatedAt: string }>('/api/state', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(state) }),
  saveKeepalive: (state: GlobalReaderState) => fetch(apiUrl('/api/state'), { method: 'PUT', credentials: 'include', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(state) }),
};
